import { render, staticRenderFns } from "./VouchersBuy.vue?vue&type=template&id=807ead9c&"
import script from "./VouchersBuy.vue?vue&type=script&lang=js&"
export * from "./VouchersBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('807ead9c')) {
      api.createRecord('807ead9c', component.options)
    } else {
      api.reload('807ead9c', component.options)
    }
    module.hot.accept("./VouchersBuy.vue?vue&type=template&id=807ead9c&", function () {
      api.rerender('807ead9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/VouchersBuy.vue"
export default component.exports